export const cartActionTypes = {
    TOGGLE_CART:'TOGGLE_CART',
    ADD_ITEM:'ADD_ITEM',
    REMOVE_ITEM:'REMOVE_ITEM',
    CLEAR_ITEM_FROM_CART: 'CLEAR_ITEM_FROM_CART',
    CLEAR_CART:'CLEAR_CART'
}